import { AppComponent } from "../../app.component";
import { DashboardComponent } from "../views/dashboard/dashboard.component";
import { RegistroComponent } from "../views/registro/registro.component";
import { PeticionComponent } from "../views/peticion/peticion.component";
import { ConsultaWarehouseComponent } from "../views/whr/consulta/consulta-warehouse.component";
import { WhrDetalleComponent } from "../views/whr/whr-detalle/whr-detalle.component";
import { OrdenpagoComponent } from "../views/ordenpago/ordenpago.component";
import { EdicionclienteComponent } from "../views/cliente/edicion-perfil/edicion-perfil.component";
import { NotificacionComponent } from "../views/notificacion/notificacion.component";


const appState = {
  name: "app",
  redirectTo: "dashboard",
  component: AppComponent,
  data: {requiresAuth: true}
};

const dashboardState = {
  parent: "app",
  name: "dashboard",
  url: "/dashboard",
  component: DashboardComponent,
  data: {requiresAuth: true}
};

const registroState = {
  name: "registro",
  url: "/registro",
  component: RegistroComponent,
  data: {isPublicState: true}
};

const peticionState = {
  parent: "app",
  name: "consultaPeticion",
  url: "/peticion",
  component: PeticionComponent,
  data: {requiresAuth: true}
};

const consultaWarehouseState = {
  parent: "app",
  name: "warehouse",
  url: "/warehouse",
  component: ConsultaWarehouseComponent,
  data: {requiresAuth: true}
};

const whrDetalleState = {
  parent: "app",
  name: "whrdetalle",
  url: "/warehouse/:nro_whr",
  component: WhrDetalleComponent
};

const ordenPagoState = {
  parent: "app",
  name: "consultaOrdenPago",
  url: "/ordenpago/?referencia",
  component: OrdenpagoComponent,
  data: {requiresAuth: true}
};

const detalleClienteState = {
  parent: "app",
  name: "detallecliente",
  url: "/detallecliente",
  component: EdicionclienteComponent,
  data: {requiresAuth: true}
};

const notificacioneState = {
  parent: "app",
  name: "notificaciones",
  url: "/notificaciones",
  component: NotificacionComponent,
  data: {requiresAuth: true}
};

export const CONTROL_APP_STATE = [
  appState,
  dashboardState,
  registroState,
  peticionState,
  consultaWarehouseState,
  whrDetalleState,
  ordenPagoState,
  detalleClienteState,
  notificacioneState
];


// WEBPACK FOOTER //
// ./src/app/control-app/config/control-app.states.ts